import { render, staticRenderFns } from "./HasEcommerceFeatureEnabled.vue?vue&type=template&id=a5416afa"
import script from "./HasEcommerceFeatureEnabled.vue?vue&type=script&lang=js"
export * from "./HasEcommerceFeatureEnabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports